import React, { lazy } from 'react';
import Loadable from 'src/components/Loadable';

const ProfileView = Loadable(
  lazy(() => import('src/pages/manage/profile/ProfileView'))
);
const InstancesView = Loadable(
  lazy(() => import('src/pages/manage/instances/InstancesView'))
);

const routes = [
  {
    path: 'manage/profile',
    element: <ProfileView />
  },
  {
    path: 'manage/zendesk-instances',
    element: <InstancesView />
  }
];

export default routes;
